module.exports = __webpack_public_path__ + "img/c-thermometer-img4-2.9c76417e.png";